<div class="gauge-chart">
  <span [class]="page === 'ExternalPage' ? 'min-external' : 'min-landing'">{{data?.n}}{{data?.unit}}</span>
  <div class="{{data.name}}" id="chart"></div>
  <span [class]="page === 'ExternalPage' ? 'max-external' : 'max-landing'">{{data?.m}}{{data?.unit}}</span>
</div>